import { Grid, Typography, Box, TextField, IconButton, InputAdornment } from "@mui/material"
import { Visibility, VisibilityOff } from "@mui/icons-material"
import { useAppSelector, useAppDispatch } from "../../../hooks/store-hooks"
import { usePasswordRecoveryService } from "../../../../use-cases/auth/usePasswordRecoveryService"
import { setCreateNewPasswordFormTouchedState, validateCreateNewPasswordForm, setCreateNewPasswordFormErrorsState } from "../../../../application/states/auth"
import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"

export const CreateNewPasswordForm = () => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false)
  const dispatch = useAppDispatch()
  const createNewPasswordForm = useAppSelector((state) => state.auth.createNewPasswordForm)
  const {
    setCreateNewPasswordFormPassword,
    setCreateNewPasswordFormConfirmPassword
  } = usePasswordRecoveryService()

  useEffect(() => {
    // Se houver token na URL, garantir que estamos no passo correto
    if (token) {
      // Token detectado - o componente PasswordRecoveryIndex já ajustou o step
    }
  }, [token])
  return <>
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h5" component="h1" align="center" color="primary" fontWeight="bold">
          Recuperar senha
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" component="p" align="center">
          Insira uma senha segura que atenda aos requisitos abaixo. Após criar a nova senha, você será redirecionado para a página de login.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Box mt={2} p={2} sx={{ backgroundColor: '#f5f5f5', borderRadius: 1 }}>
          <Typography variant="body2" component="p" align="left" fontWeight="bold" gutterBottom>
            Requisitos para uma senha segura:
          </Typography>
          <Typography variant="body2" component="ul" sx={{ margin: 0, paddingLeft: 3 }}>
            <li>Mínimo de 8 caracteres</li>
            <li>Pelo menos uma letra minúscula (a-z)</li>
            <li>Pelo menos uma letra maiúscula (A-Z)</li>
            <li>Pelo menos um número (0-9)</li>
            <li>Pelo menos um caractere especial (!@#$%&*()_+=|&lt;&gt;?&#123;&#125;[]~-)</li>
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Nova senha"
          value={createNewPasswordForm.fields.password}
          onChange={(e) => {
            setCreateNewPasswordFormPassword({
              password: e.target.value
            })
            // Marcar como touched e validar em tempo real
            if (!createNewPasswordForm.touched) {
              dispatch(setCreateNewPasswordFormTouchedState({ touched: true }))
            }
            // Validar em tempo real
            const errors = validateCreateNewPasswordForm({
              password: e.target.value,
              confirmPassword: createNewPasswordForm.fields.confirmPassword
            })
            dispatch(setCreateNewPasswordFormErrorsState({ errors }))
          }}
          onBlur={() => {
            // Garantir que está touched quando sair do campo
            dispatch(setCreateNewPasswordFormTouchedState({ touched: true }))
            // Validar ao sair do campo
            const errors = validateCreateNewPasswordForm({
              password: createNewPasswordForm.fields.password,
              confirmPassword: createNewPasswordForm.fields.confirmPassword
            })
            dispatch(setCreateNewPasswordFormErrorsState({ errors }))
          }}
          error={Boolean(createNewPasswordForm.touched && createNewPasswordForm.errors.find(item => item.key === 'password'))}
          helperText={
            createNewPasswordForm.touched && createNewPasswordForm.errors.find(item => item.key === 'password') ? (
              <div dangerouslySetInnerHTML={{
                __html: createNewPasswordForm.errors.find(item => item.key === 'password')?.message ?? ''
              }}>
              </div>
            ) : 'Digite uma senha segura que atenda aos requisitos acima'
          }
          name="new-password"
          fullWidth
          id="new-password"
          autoFocus
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />

      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Confirmar nova senha"
          value={createNewPasswordForm.fields.confirmPassword}
          onChange={(e) => {
            setCreateNewPasswordFormConfirmPassword({
              confirmPassword: e.target.value
            })
            // Marcar como touched e validar em tempo real
            if (!createNewPasswordForm.touched) {
              dispatch(setCreateNewPasswordFormTouchedState({ touched: true }))
            }
            // Validar em tempo real
            const errors = validateCreateNewPasswordForm({
              password: createNewPasswordForm.fields.password,
              confirmPassword: e.target.value
            })
            dispatch(setCreateNewPasswordFormErrorsState({ errors }))
          }}
          onBlur={() => {
            // Garantir que está touched quando sair do campo
            dispatch(setCreateNewPasswordFormTouchedState({ touched: true }))
            // Validar ao sair do campo
            const errors = validateCreateNewPasswordForm({
              password: createNewPasswordForm.fields.password,
              confirmPassword: createNewPasswordForm.fields.confirmPassword
            })
            dispatch(setCreateNewPasswordFormErrorsState({ errors }))
          }}
          error={Boolean(createNewPasswordForm.touched && createNewPasswordForm.errors.find(item => item.key === 'confirmPassword'))}
          helperText={
            createNewPasswordForm.errors.find(item => item.key === 'confirmPassword')?.message
          }
          name="confirm-new-password"
          fullWidth
          id="confirm-new-password"
          type={showConfirmPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  edge="end"
                >
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />
      </Grid>
    </Grid>
  </>
}